import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { MenuItem, FormControl, Select, Checkbox, ListItemText } from '@mui/material';
import { useIsMobile } from '@monorepo-web/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare, faSquareCheck } from '@fortawesome/free-regular-svg-icons';
import { useTypedTheme } from '@monorepo-web/styles';
import { ReactComponent as ChartLine } from '../../assets/chart-line.svg';
import { Container } from '../Container';
import { ButtonWrapper, SelectColumn, SelectWrapper, StyledButton } from './style';
import MarcarDesmarcarButton from '../Dropdown/BotaoMarcarDesmarcar/index';
const defaultOptions = [
    { label: 'CDI', value: 'CDI' },
    { label: '% do CDI', value: 'percent(CDI)' },
    { label: 'IBOV', value: 'IBOV' },
    { label: 'Excesso sobre o IBOV', value: 'exc(IBOV)' },
    { label: 'IBRX', value: 'IBRX' },
    { label: 'IPCA', value: 'IPCAdp' },
    { label: 'IPCA+4', value: 'IPCAdp+4%aa' },
    { label: 'IPCA+5', value: 'IPCAdp+5%aa' },
    { label: 'IPCA+6', value: 'IPCAdp+6%aa' },
    { label: 'Poupança', value: 'POUPANCA1d' },
];
export default function Benchmarks({ selectedBenchmarks, dispatchSelectedBenchmarks, customItemOptions, disabled }) {
    const theme = useTypedTheme();
    const isMobile = useIsMobile();
    const [option] = useState([]);
    const [openSelect, setOpenSelect] = useState(false);
    const [benchmark, setBenchmark] = useState([]);
    useEffect(() => {
        if (openSelect) {
            setBenchmark(selectedBenchmarks ? [...selectedBenchmarks] : []);
        }
    }, [openSelect]);
    const menuItemOptions = customItemOptions && customItemOptions.length > 0 ? customItemOptions : defaultOptions;
    const handleClick = () => {
        dispatchSelectedBenchmarks([...benchmark], false);
        setOpenSelect(false);
    };
    function MenuItemStyles() {
        return {
            backgroundColor: theme.dropSelectorColor,
            color: theme.backgroundColorSecondary,
            fontFamily: 'Roboto !important',
            marginTop: -8,
            marginBottom: -8,
        };
    }
    const clickOnBench = (bench) => {
        if (benchmark === null || benchmark === void 0 ? void 0 : benchmark.includes(bench)) {
            const arr = [...benchmark];
            arr.splice(benchmark.indexOf(bench), 1);
            setBenchmark(arr);
        }
        else {
            setBenchmark([...benchmark, bench]);
        }
    };
    const avoidPropagation = (e) => {
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        else if (window.event) {
            window.event.cancelBubble = true;
        }
    };
    return (_jsx(Container, { children: _jsx(FormControl, Object.assign({ variant: "standard", style: { display: 'flex', flexDirection: 'row' } }, { children: _jsx(Select, Object.assign({ disabled: disabled, id: "demo-multiple-checkbox-label", multiple: true, MenuProps: {
                    PaperProps: {
                        style: {
                            overflowY: 'hidden',
                            backgroundColor: theme.dropSelectorColor,
                        },
                    },
                }, open: openSelect, onClick: () => {
                    if (!disabled) { // não permitir utilizar botão quando minizar o modal de loading
                        setOpenSelect(!openSelect);
                    }
                }, displayEmpty: true, value: option, renderValue: () => {
                    return _jsx("div", Object.assign({ style: { color: theme.titleFontColor } }, { children: "Benchmarks" }));
                }, inputProps: {
                    'aria-label': 'Without label',
                    IconComponent: () => _jsx(ChartLine, { width: "25px", fill: disabled ? theme.disabledColor : theme.iconsColor, style: { cursor: "pointer" } }),
                } }, { children: _jsxs(SelectWrapper, Object.assign({ style: {
                        maxHeight: '70vh',
                        overflowY: 'auto',
                        paddingBottom: '10px',
                        display: 'flex',
                        flexDirection: 'column',
                    } }, { children: [_jsx("div", Object.assign({ onClick: (e) => {
                                avoidPropagation(e);
                                setOpenSelect(true);
                            }, style: { padding: '8px 16px' } }, { children: _jsx(MarcarDesmarcarButton, { selectedItems: benchmark, allOptions: menuItemOptions.map(opt => opt.value), onChange: setBenchmark, avoidPropagation: avoidPropagation, style: { width: '130px' } }) })), _jsxs("div", Object.assign({ style: { display: 'flex', width: '100%' } }, { children: [_jsx(SelectColumn, Object.assign({ onClick: (e) => {
                                        avoidPropagation(e);
                                        setOpenSelect(true);
                                    } }, { children: menuItemOptions
                                        .slice(0, isMobile ? 0 : Math.ceil(menuItemOptions.length / 2))
                                        .map((item) => (_jsxs(MenuItem, Object.assign({ style: MenuItemStyles(), value: item.value, onClick: () => {
                                            clickOnBench(item.value);
                                        } }, { children: [_jsx(Checkbox, { checked: benchmark === null || benchmark === void 0 ? void 0 : benchmark.includes(item.value), icon: _jsx(FontAwesomeIcon, { icon: faSquare, style: { color: theme.backgroundColorSecondary }, fontSize: '1.5rem' }), checkedIcon: _jsx(FontAwesomeIcon, { icon: faSquareCheck, style: { color: theme.backgroundColorSecondary }, fontSize: '1.5rem' }) }), _jsx(ListItemText, { primary: item.label })] }), item.label))) })), _jsxs(SelectColumn, Object.assign({ onClick: (e) => {
                                        avoidPropagation(e);
                                        setOpenSelect(true);
                                    } }, { children: [menuItemOptions
                                            .slice(isMobile ? 0 : Math.ceil(menuItemOptions.length / 2), menuItemOptions.length)
                                            .map((item) => (_jsxs(MenuItem, Object.assign({ style: MenuItemStyles(), value: item.value, onClick: () => {
                                                clickOnBench(item.value);
                                            } }, { children: [_jsx(Checkbox, { checked: benchmark === null || benchmark === void 0 ? void 0 : benchmark.includes(item.value), icon: _jsx(FontAwesomeIcon, { icon: faSquare, style: { color: theme.backgroundColorSecondary }, fontSize: '1.5rem' }), checkedIcon: _jsx(FontAwesomeIcon, { icon: faSquareCheck, style: { color: theme.backgroundColorSecondary }, fontSize: '1.5rem' }) }), _jsx(ListItemText, { primary: item.label })] }), item.label))), _jsx(ButtonWrapper, { children: _jsx(StyledButton, Object.assign({ onClick: (e) => {
                                                    avoidPropagation(e);
                                                    handleClick();
                                                } }, { children: "Aplicar" })) })] }))] }))] })) })) })) }));
}
